import { trpc } from '@/services/trpc';

export function useHttpToolMutation() {
  const utils = trpc.useUtils();

  const invalidate = async () => utils.httpTools.findAll.invalidate();

  const create = trpc.httpTools.create.useMutation({ onSuccess: invalidate });

  const update = trpc.httpTools.update.useMutation({ onSuccess: invalidate });

  const remove = trpc.httpTools.delete.useMutation({ onSuccess: invalidate });

  const testConnection = trpc.httpTools.testConnection.useMutation();

  return { create, update, remove, testConnection };
}
